import React, { Component } from "react"
import './contractSign.less'






export default class PowerStation extends Component {
	constructor(props) {
		super(props);
		this.state={}
	}
	render() {
		return (
			<div>
			   <p>合同签署</p>
			</div>
		)
	}
}